module.exports = __webpack_public_path__ + "static/img/autCt_bg_05.317cebf1.svg";